
    <input
      [(ngModel)]="this.field.value"
      type="search"
      pInputText
      placeholder="{{ 'FILTER_MANAGEMENT.MATCH_MODE_CONTAINS' | translate }}"
    />
  